import React from "react";
import { useNavigate } from "react-router-dom";
import { Header } from "../../../components/header";
import { Loading } from "../../../components/loading";
import { EmptyList } from "../../../components/empty-list";
import { Table, TableHeader, TableBody, TableRow, TableCell } from "../../../components/tables";
import { SendIcon } from "../../../components/icons";
import { useThemes } from "../hooks";

export const ThemesList: React.FC = () => {
  const navigate = useNavigate();
  const { data, loading } = useThemes();

  return (
    <>
      <Header
        title="Thèmes"
        subtitle="Styles de base pour les sites de prospection générés"
        buttons={[
          {
            actionText: "Nouveau thème",
            bgColor: "indigo",
            textColor: "white",
            link: `/theme/create`,
            icon: <SendIcon />,
          },
        ]}
      />

      <div className="main-container">
        <div className="p-4 mb-6 bg-white shadow rounded overflow-x-auto">
          {loading ? (
            <Loading />
          ) : !data?.themes?.results?.length ? (
            <EmptyList text="Aucun thème" />
          ) : (
            <Table>
              <TableHeader>
                <TableRow hover={false}>
                  <TableCell header>Code</TableCell>
                  <TableCell header>Nom</TableCell>
                </TableRow>
              </TableHeader>
              <TableBody>
                {data?.themes?.results?.map((theme) => (
                  <TableRow
                    key={`theme-${theme.id}`}
                    onClick={() => navigate(`/theme/${theme.id}/update`)}
                  >
                    <TableCell>{theme.code}</TableCell>
                    <TableCell>{theme.name}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </div>
      </div>
    </>
  );
};
